import moment from 'moment';

import { TimeCard } from '~/data/worktime';

export const timerJustStarted = (todaysTimeCard?: TimeCard): boolean => {
  if (todaysTimeCard) {
    const now = moment().format('HH:mm');
    return todaysTimeCard.timeBlocks.some(({ from, to }) => {
      return from && !to && moment(from, 'HH:mm:ss').format('HH:mm') === now;
    });
  }

  return false;
};
